import Marquee from "react-fast-marquee";

const WORDS = [
  "E-commerce",
  "Omnichannel",
  "Digital strategi",
  "Vækst",
  "Ledelse",
  "Unified Commerce",
];

export const MarqueeStrip = () => (
  <section
    data-testid="marquee-strip"
    className="bg-[#1f3d2b] py-8 md:py-10"
  >
    <Marquee speed={38} autoFill gradient={false}>
      {WORDS.map((w, i) => (
        <span
          key={i}
          className="font-display italic font-light text-4xl md:text-6xl text-[#f4f4f2] mx-8 flex items-center gap-8"
        >
          {w}
          <span className="text-[#8fae9b] not-italic">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
